const createGeneralProductInformationValidation = isValid => ({
    isValid,
    errors: isValid ? [] : [{
        code: 'GENERAL_PRODUCT_INFORMATION_INVALID',
        messageKey: 'Page(ReceivedRequest):Component(StepItem):general-product-information-invalid',
    }],
})

export { createGeneralProductInformationValidation }
export default createGeneralProductInformationValidation
